import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { DthcActions, GlobalNotifications, Intent } from '../../../Modules';
import Formsy from 'formsy-react';
import styles from './Recipient.scss';
import RecipientFields from './RecipientFields';

export default class RecipientEditDesktop extends React.Component {
  static propTypes = {
    localRecipient: PropTypes.object.isRequired,
    commitUpdate: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.reset = this.reset.bind(this);
    this.onValidSubmit = this.onValidSubmit.bind(this);
    this.onInvalidSubmit = this.onInvalidSubmit.bind(this);
    this.state = {
      submitted: false
    };
  }

  onValidSubmit() {
    this.setState({ submitted: true });
    this.props.commitUpdate(this.props.closeHandler);
  }

  onInvalidSubmit() {
    this.setState({ submitted: true });
    GlobalNotifications.show({
      message: 'Unable to update recipient',
      intent: Intent.DANGER
    });
  }

  reset(e) {
    this.props.reset();
    this.props.closeHandler(e);
    e.stopPropagation();
  }

  render() {
    return (
      <Formsy.Form
        onValidSubmit={this.onValidSubmit}
        onInvalidSubmit={this.onInvalidSubmit}
        className={styles.active}
      >
        <Grid padded relaxed stackable>
          <Grid.Row columns={1}>
            <Grid.Column>
              <RecipientFields
                localRecipient={this.props.localRecipient}
                onChange={this.props.onChange}
                submitted={this.state.submitted}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <DthcActions reset={this.reset} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Formsy.Form>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/Recipient/RecipientEditDesktop.js